import { collection, onSnapshot } from 'firebase/firestore';
import { useOrganizationIdSelector } from 'modules/authorization';
import { db } from 'modules/firebase';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { clientsFirestoreConverter } from '../const/clientsFirestoreConverter';
import { clientAction } from '../redux';

export function useClientsSubscription() {
  const organizationId = useOrganizationIdSelector();
  const dispatch = useDispatch();

  useEffect(() => {
    const collectionReference = collection(
      db,
      organizationId,
      'clients',
      'entities',
    ).withConverter(clientsFirestoreConverter);

    return onSnapshot(
      collectionReference,
      (snapshot) =>
        dispatch(
          clientAction.onSnapshotUpdate(snapshot.docs.map((doc) => doc.data())),
        ),
      (error) => dispatch(clientAction.onSnapshotError(error)),
    );
  }, [organizationId]);
}
